<template lang="pug">
  v-layout(row justify-center)
    v-dialog(data-cy="save-recurring.dialog" :value="showModal" @input="$emit('input')" persistent max-width="540")
      v-card
        title-bar(data-cy="save-recurring.title" dark)
          span Edit recurring event
        v-card-text
          v-radio-group(v-model="value.updateType")
            v-layout(wrap)
              v-flex(xs12)
                v-layout(align-center wrap)
                  v-radio(:value="1" label="This event")

              v-flex(xs12)
                v-layout(align-center wrap)
                  v-radio(:value="2" label="This and following events")
        v-card-actions
          v-spacer
          v-btn(data-cy="save-recurring.cancel" flat @click="closeDialog(false)") Cancel
          v-btn.primary(data-cy="save-recurring.submit" @click="closeDialog(true)") OK
</template>

<script>

import TitleBar from '@/Core/components/TitleBar';

export default {
  components: {
    TitleBar,
  },

  props: {
    value: {
      type: Object,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeDialog(saveRecurring = false) {
      if ((this.value.updateType && saveRecurring) || !saveRecurring) {
        this.$emit('input', this.value);
        this.$emit('close', saveRecurring);
      }
    },
  },
};

</script>
